"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const TextField_1 = __importDefault(require("@material-ui/core/TextField"));
const styles_1 = require("@material-ui/core/styles");
const core_1 = require("@material-ui/core");
const useStyle = styles_1.makeStyles({
    labelBefore: {
        paddingRight: "5px",
        paddingTop: "5px",
        textAlign: "right"
    },
    labelAfter: {
        paddingTop: "10px",
    },
    wrapper: {},
    textfield: {
        width: "100%"
    },
    disabled: {
        marginTop: "2px",
        color: "#cfcfcf"
    },
    outerGrid: {
        textAlign: "center"
    },
    input: {
        border: "unset",
    }
});
function TextFieldKTR(props) {
    const classes = useStyle();
    const theme = styles_1.useTheme();
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(core_1.Grid, { className: classes.outerGrid, item: true },
            react_1.default.createElement(TextField_1.default, { label: props.labelBefore, id: props.id, name: props.name, InputProps: {
                    readOnly: props.readonly,
                    endAdornment: react_1.default.createElement(core_1.InputAdornment, { position: "start" },
                        " ",
                        props.labelAfter),
                    disableUnderline: true,
                    className: (props.value !== undefined && props.value !== "" && props.readonly !== true) ? classes.input : ""
                }, InputLabelProps: {
                    style: { color: theme.palette.text.primary },
                    shrink: true,
                }, type: props.type, fullWidth: true, error: props.error || false, helperText: props.error ? props.errorText : '', onChange: props.onChange, defaultValue: props.defaultValue, onBlur: props.onBlur, disabled: props.readonly || props.disabled, placeholder: props.placeholder, margin: "normal", value: props.value === undefined ? "" : props.value }))));
}
exports.default = TextFieldKTR;
//# sourceMappingURL=TextField.js.map